import { render, staticRenderFns, recyclableRender, components } from "./mpvueCityPicker.vue?vue&type=template&id=3715812b&"
var renderjs
import script from "./mpvueCityPicker.vue?vue&type=script&lang=js&"
export * from "./mpvueCityPicker.vue?vue&type=script&lang=js&"
import style0 from "./mpvueCityPicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/mpvue-citypicker/mpvueCityPicker.vue"
export default component.exports